import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "../AppContext/AuthContext";
import CorporateFacilityContext from "../AppContext/CorporateFacilityContext";
import { AppLoadingOverlay } from "../AppComponents/CorporateDashboard";
import LandingPage from "../Pages/LandingPage";

const RootRoute = () => {
    const { IsAuthenticated, IsAuthChecking } = useContext(AuthContext);
    const corporateCtx = useContext(CorporateFacilityContext);

    if (IsAuthChecking) {
        return <AppLoadingOverlay />;
    }

    if (IsAuthenticated) {
        if (corporateCtx && !corporateCtx.profileReady) {
            return <AppLoadingOverlay />;
        }
        if (corporateCtx?.requiresFacilitySelection) {
            return <Navigate to="/corporate-communities" replace />;
        }
        return <Navigate to="/slideapp" replace />;
    }

    return <LandingPage />;
};

export default RootRoute;
